import styled from 'styled-components';

export default styled.section`
  .home-owning-posts .inner header h2 {
    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      max-width: 15rem;
      font-size: 26px;
    }
  }

  .mortgage-calc {
    .content{
      @media (min-width: ${props => props.theme.breakpoints.desktopLarge}) {
        width: 900px;
      }
    }
  }

  .paragraph-section {
    padding-bottom: 6rem;
    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      padding-bottom: 1rem;
    }
  }

  .section-title {
    margin-top: 0;
  }

  @media (max-width: ${props => props.theme.breakpoints.desktop}) {
    
    .title-heading {
      &--mobile {
        display: block;
      }
      &--desktop {
        display: none;
      }
    }

  }

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    .title-heading {
      &--mobile {
        display: none;
      }
      &--desktop {
        display: block;
      }
    }
  }

  .paragraph-section {
    padding-top: 5rem;
    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      padding-bottom: 1rem;
    }
  }

  .insurance-claim-section {
    padding-top: 5rem;
    @media (min-width: ${props => props.theme.breakpoints.desktopLarge}) {
      min-width: 33rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.desktop}) {
      padding-top: 0;
    }
  }

  .contact-us-section{
    position: relative;
    max-height: 224px;
    background-color: ${props => props.theme.colors.darkBlue};
    border: 2px solid ${props => props.theme.colors.darkBlue};;
    margin-top: 80px;
    @media (max-width: ${props => props.theme.breakpoints.desktopMedLarge}){
       margin-top: 150px;
     }
     @media (max-width: 408px){
       padding-bottom: 3rem;
     }

    .contact-card{
     margin-top: -100px;
     @media (max-width: ${props => props.theme.breakpoints.desktopMedLarge}){
       margin-top: -160px;
     }
    }
  }
   
`